var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn-toggle', {
    staticClass: "cash-list-type grey lighten-4",
    staticStyle: {
      "width": "100%",
      "border-radius": "8px!important"
    },
    attrs: {
      "borderless": "",
      "active-class": "white elevation-4",
      "color": "primary"
    },
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.query.type,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "type", $$v);
      },
      expression: "query.type"
    }
  }, [_vm._l(_vm.types, function (_ref) {
    var text = _ref.text,
        value = _ref.value;
    return [_c('v-btn', _vm._b({
      key: text,
      staticStyle: {
        "border-radius": "8px!important"
      },
      attrs: {
        "width": "calc(100% / ".concat(_vm.types.length, ")")
      }
    }, 'v-btn', {
      value: value
    }, false), [_vm._v(" " + _vm._s(text) + " ")])];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }